import { render, staticRenderFns } from "./MatchGSRPReferral.vue?vue&type=template&id=146ba4c4&"
import script from "./MatchGSRPReferral.vue?vue&type=script&lang=ts&"
export * from "./MatchGSRPReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports